import { EMPTY_CELL } from '@/shared/constants'

import { fixed, hasFigure } from './numberFormat'

/**
 * A backend `…Ratio` field — a share, not a percentage — drawn as one: `0.125` → `12.5%`,
 * `1` → `100.0%`. `null`, `undefined` and `NaN` are `—`, because a ratio the backend had no
 * base for is not `0%`.
 *
 * `digits` is how many decimals the percentage keeps, trailing zeros included, so a column
 * of them lines up (`0.5` at one digit is `50.0%`). A metric whose precision comes from the
 * backend passes its own.
 *
 * A field that already arrives in percent (`12.5`) is `formatPercent`.
 */
export function formatRatio(
  value: number | null | undefined,
  digits = 1
): string {
  if (!hasFigure(value)) return EMPTY_CELL

  return `${fixed(digits).format(value * 100)}%`
}
